var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGericht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 250,
    viewBox: "0 0 360 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 250,
    fill: "#0B0C10"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 340,
    height: 50,
    rx: 5,
    fill: "#66FCF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 50,
    height: 60,
    rx: 5,
    fill: "#66FCF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 133,
    width: 50,
    height: 70,
    rx: 5,
    fill: "#66FCF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 50,
    width: 50,
    height: 190,
    rx: 5,
    fill: "#66FCF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 190,
    width: 160,
    height: 50,
    rx: 5,
    fill: "#66FCF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 157.261,
    height: 49.2816,
    rx: 5,
    transform: "matrix(-0.893705 -0.448654 0.454029 -0.890987 148.901 179.163)",
    fill: "#66FCF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGericht);
export default __webpack_public_path__ + "static/media/gericht.a883e04c975247ccb445f4434240b273.svg";
export { ForwardRef as ReactComponent };